"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotification = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("@components/icons");
require("./styles.scss");
const ErrorNotification = (props) => {
    const { children } = props;
    return (react_1.default.createElement("div", { className: "c-error-notification" },
        react_1.default.createElement("div", { className: "c-error-notification__wrapper" },
            react_1.default.createElement("div", { className: "c-error-notification__content" },
                react_1.default.createElement("div", { className: "c-error-notification__preview" },
                    react_1.default.createElement(icons_1.FailIcon, null)),
                react_1.default.createElement("div", { className: "c-error-notification__body" }, children)))));
};
exports.ErrorNotification = ErrorNotification;
